export const ONE_DRIVE_CONUSMER_BASE_URL = 'https://1drv.ms';
export const DROP_BOX_BASE_URL = 'https://www.dropbox.com';
export const BOX_BASE_URL = 'https://app.box.com';
export const GDRIVE_BASE_URL = 'https://drive.google.com';
export const GDRIVE_DOCS_BASE_URL = 'https://docs.google.com';
export const UNDEFINED_EXPIRATION_DATE = '0001-01-01T00:00:00Z';
